import * as React from "react";
import { SVGProps } from "react";
export const CalendarFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.25 18.333C3.764 18.333 3.35067 18.163 3.01 17.823C2.67 17.4823 2.5 17.069 2.5 16.583V5.16699C2.5 4.68099 2.67 4.26766 3.01 3.92699C3.35067 3.58699 3.764 3.41699 4.25 3.41699H4.917V2.52099C4.917 2.28499 5.00033 2.08366 5.167 1.91699C5.33367 1.75033 5.542 1.66699 5.792 1.66699C6.028 1.66699 6.23267 1.75366 6.406 1.92699C6.58 2.10099 6.667 2.30599 6.667 2.54199V3.41699H13.333V2.52099C13.333 2.28499 13.4163 2.08366 13.583 1.91699C13.7497 1.75033 13.958 1.66699 14.208 1.66699C14.444 1.66699 14.649 1.75366 14.823 1.92699C14.9963 2.10099 15.083 2.30599 15.083 2.54199V3.41699H15.75C16.236 3.41699 16.6493 3.58699 16.99 3.92699C17.33 4.26766 17.5 4.68099 17.5 5.16699V16.583C17.5 17.069 17.33 17.4823 16.99 17.823C16.6493 18.163 16.236 18.333 15.75 18.333H4.25ZM4.25 16.583H15.75V8.37499H4.25V16.583Z"
            fill="currentColor"
        />
    </svg>
);
CalendarFillIcon.displayName = "CalendarFillIcon";
